export function mapEquipment(equipment) {
  return {
    equipmentType: equipment.equipmentType,
    sizeType: equipment.type,
    transportCondition: equipment.transportCondition,
    vgmWeight: equipment.weight.vgmWeight,
    vgmWeightUnit: equipment.weight.vgmWeightUnit,
  };
}

export function mapStuffing({ stuffing = [] }, equipmentHashMap) {
  return stuffing.map(stuffing => ({
    identifier: stuffing.identifier,
    stuffing: stuffing.numberOfPackages,
    ...equipmentHashMap[stuffing.identifier],
  }));
}

export function mapBillOfLading(billOfLading) {
  const [customsReponse] = billOfLading.technicalInfo.parentDocument;
  const {
    consignment: [consignment],
    equipment = [],
  } = billOfLading.consignmentData;
  const { seaVoyage, goodsItem } = consignment;

  const equipmentHashMap = equipment.reduce((acc, curr) => {
    acc[curr.identifier] = mapEquipment(curr);
    return acc;
  }, {});

  const mappedBOL = {
    customsResponse: {
      dataProvider: customsReponse.dataProviderCode,
      response: customsReponse.code,
      description: customsReponse.description,
    },
    vesselDetails: {
      imo: seaVoyage.vessel.imo,
      cargoAgent: seaVoyage.cargoAgent.agentCode,
      consignmentNumber: consignment.sequenceNr,
    },
    voyageInformation: {
      portOfLoading: seaVoyage.portOfLoading.unloCode,
      portOfDestination: seaVoyage.portOfDestination.unloCode,
    },
    stayInformation: {
      stayNumber: seaVoyage.vesselStay.stayNumber,
      berthPlace: seaVoyage.portOfDestination.terminalCode,
    },
    details: goodsItem.map(item => ({
      itemNumber: item.sequenceNr,
      packageType: item.packageType,
      quantity: item.numberOfPackages,
      commodity: item.description,
      grossWeight: item.grossWeight,
      grossWeightUnit: item.grossWeightUnit,
      customsStatus: item.customsStatus,
      equipment: mapStuffing(item, equipmentHashMap),
    })),
  };

  return mappedBOL;
}
